import { atom, selector } from 'recoil';

// Função para obter o valor inicial do localStorage de forma segura
const getInitialSidebarState = () => {
  try {
    const stored = localStorage.getItem('sidebarExpanded');
    // Se não há valor salvo, retorna false (recolhido por padrão)
    if (stored === null) return false;
    // Converte string para boolean
    return stored === 'true';
  } catch (error) {
    console.warn('Erro ao ler sidebarExpanded do localStorage:', error);
    return false; // Fallback para recolhido
  }
};

// Estado do sidebar expandido/recolhido
export const sidebarExpandedState = atom({
  key: 'sidebarExpanded',
  default: getInitialSidebarState()
});

export const sidebarExpandedSelector = selector({
  key: 'sidebarExpandedSelector',
  get: ({ get }) => get(sidebarExpandedState),
  set: ({ set }, newValue) => {
    try {
      localStorage.setItem('sidebarExpanded', String(newValue));
    } catch (error) {
      console.warn('Erro ao salvar sidebarExpanded no localStorage:', error);
    }
    set(sidebarExpandedState, newValue);
  }
});

// Estado dos submenus expandidos
export const expandedMenusState = atom({
  key: 'expandedMenus',
  default: {}
});

// Estado do drawer off-canvas do sidebar em telas < 1024px (não persiste)
export const mobileSidebarOpenState = atom({
  key: 'mobileSidebarOpen',
  default: false
});
